import React from 'react';

import { I18n } from 'aws-amplify';

import { Task } from '../../../utils/task';

import CheckboxField from '../../form/checkbox-field';

import constants from '../../../constants';

import { scrollToTop } from '../../../utils/ui';

import TermsPT from './_terms.pt';
import TermsES from './_terms.es';
import TermsEN from './_terms.en';

class TermsForm extends React.Component {
    constructor(props) {

        super(props);

        const { bPitch = {} } = props;

        this.state = {
            fields: {
                terms: {
                    value: true,
                    onChange: this.onChangeFormCheckbox.bind(this, 'terms'),
                    successIcon: false,
                    markAsRequired: true
                },
            },
            errors: {},
            form: { ...bPitch },
            task: {},
            submit_task: {}
        }
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const task = this.props.task || {};
        const prev = prevProps && prevProps.task || {};

        //console.dir({ task: task, prev: prev });

        if (task != prev) {

            var nextState = Object.assign({}, prevState, { task: task });

            const { bPitch = {} } = this.props;

            Object.keys(this.state.fields).forEach((item) => {

                if (bPitch[item]) {
                    nextState.form[item] = bPitch[item];
                }

            });

            this.setState(nextState);
        }
    }

    onChangeFormCheckbox(prop, e) {

        const value = e.target.checked;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;
        }, () => this.onSave());
    }

    getData() {

        var data = {
            projectId: this.props.match.params.projectId,
            ...this.props.bPitch,
            ...this.state.form
        };

        return data;
    }

    onSave() {

        var submit_task = new Task();

        submit_task.start();

        this.setState({ submit_task: submit_task });

        this.props.update_bpitch(this.getData())
            .then(({ task, errors }) => {

                this.setState({ submit_task: task, errors: errors });
            });
    }

    render() {

        const auth = this.props.auth || {};

        const { locale } = auth;

        return (
            <div>

                <h1 className="title-bpool medium">{I18n.get("Termos")}</h1>

                <div className="bp-event-section" style={{ marginTop: '3rem', maxWidth: '50rem' }}>

                    {locale == 'pt' && <>

                        <TermsPT />

                    </>}

                    {locale == 'es' && <>

                        <TermsES />

                    </>}

                    {locale == 'en' && <>

                        <TermsEN />

                    </>}

                    <br />

                    <CheckboxField
                        {...this.state.fields.terms}
                        label={I18n.get("Li e estou de acordo")} 
                        checked={this.state.form.terms}
                        error={this.state.errors.terms} />


                </div>
            </div>
        );
    }
}

export default TermsForm;
